export default __webpack_public_path__ + "static/media/updateadmintoast.419a1eba.svg";